import { CreateDismissedNotificationResponse, GetDismissedNotificationResponse } from "@performyard/service-contracts";

import request from "./internal-base-request";

/**
 * Checks to see if user has already dismissed the current promotion
 * @params userid, notificationId
 * @returns Response is an object with a boolean for if the notification is dismissed,
 * as well as the dismissed notification count, userId and notificationId
 */

export const getDismissedNotification = async (userId: string, notificationId: string) => {
	const [response] = await request<GetDismissedNotificationResponse>(
		`/v1/dismissed-notifications/${userId}/${notificationId}`
	);

	return response;
};

/**
 * When user dismisses promotion, this function calls the internal api
 * to create the document in dismissed_notifications collection.
 * @params userid, notificationId
 * @returns Response with insertedId and acknowledged.
 */
export const dismissNotification = async (userId: string, notificationId: string) => {
	const [response] = await request<CreateDismissedNotificationResponse>(
		`/v1/dismissed-notifications/${userId}/${notificationId}`,
		{
			method: "POST",
		}
	);
	return response;
};
